<template>
  <div id="app">
    <div class="container">
      <div class="top"></div>
      <div class="container-index" style="position:relative">
        <div class="index-swiper">
          <swiper :msg="swiper" />
        </div>
        <div class="bodyLogo">
          <div class="trademark">
            <img src="../assets/img/logo1.png" />
          </div>
          <div class="trademark1">
            <img src="../assets/img/logo2.png" />
          </div>
          <div class="trademark2">
            <img src="../assets/img/logo3.jpg" />
          </div>
          <div class="trademark3">
            <img src="../assets/img/logo4.jpg" />
          </div>
          <div class="trademark4">
            <img src="../assets/img/logo5.png" />
          </div>
          <div class="trademark5">
            <img src="../assets/img/logo6.png" />
          </div>
        </div>

        <div class="index-logo">
          <img src="../assets/img/science-logo.png" />
        </div>
        <div class="undershy">
          <img src="../assets/img/undershy.png" />
        </div>
        <div class="bodyRouter">
          <div class="homepage">
            <router-link tag="a" to="/home">
              <div class="pic">
                <img src="../assets/img/homepage.png" />
              </div>
              <span class="goal" v-if="this.$store.state.num == 2">首页</span>
              <span class="goal" v-else>Home</span>
            </router-link>
          </div>
          <div class="park-info">
            <router-link tag="a" to="/information">
              <div class="pic">
                <img src="../assets/img/park-info.png" />
              </div>
              <span class="goal" v-if="this.$store.state.num == 2">公园简介</span>
              <span class="goal" v-else>About</span>
            </router-link>
          </div>
          <div class="news-center">
            <router-link to="/newscenter">
              <div class="pic">
                <img src="../assets/img/news-center.png" />
              </div>
              <span class="goal" v-if="this.$store.state.num == 2">新闻中心</span>
              <span class="goal" v-else>News</span>
            </router-link>
          </div>
          <div class="resource-pro">
            <router-link to="/resourcepro">
              <div class="pic">
                <img src="../assets/img/resource-pro.png" />
              </div>
              <span class="goal" v-if="this.$store.state.num == 2">资源保护</span>
              <span class="goal" v-else>Resources</span>
            </router-link>
          </div>
        </div>
        <div class="beianhao">
          <span class="key">蜀ICP备:</span>
                <a href="https://beian.miit.gov.cn/">
                  <span class="value">2021025467号-1</span>
                </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "../conponent/Swiper.vue";
import { swiper } from "../api/api.js";


export default {
  name: "App",
  data() {
    return {
      swiper: [],
      carousel: {
        imgType: 0,
        column: "order_num",
        order: "desc",
      },
    };
  },
  created() {
    swiper(this.carousel).then((res) => {
      this.swiper = res.data.result.records;
    });
  },
  components: {
    Swiper,
  },
};
</script>

<style lang="less" scoped>
.beianhao {
  position: absolute;
  bottom: 10px;
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: black;
  z-index: 999;
  font-weight: 600;
}
.beianhao .value {
  color: black;
}
.top {
  background-image: url("../assets/img/top.png");
  background-size: 100% 100%;
  height: 3vh;
}

.bodyLogo {
  position: absolute;
  width: 800px;
  top: 20px;
  left: 2%;
  display: flex;
  z-index: 999;

  .trademark {
    width: 80px;
    height: 60px;
    z-index: 2;
  }

  .trademark1 {
    width: 70px;
    height: 50px;
    z-index: 2;
    margin-left: 10px;
  }

  .trademark2 {
    width: 52px;
    height: 50px;
    z-index: 2;
    margin-left: 5px;
  }

  .trademark3 {
    width: 53px;
    height: 50px;
    z-index: 2;
    margin-left: 10px;
  }

  .trademark4 {
    width: 55px;
    height: 50px;
    z-index: 2;
    margin-left: 10px;
  }

  .trademark5 {
    width: 250px;
    height: 50px;
    z-index: 2;
    margin-left: 10px;
  }

  img {
    height: 100%;
    width: 100%;
  }
}

.index-logo {
  width: 540px;
  height: 240px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 70px;
  z-index: 2;

  img {
    width: 100%;
    height: 100%;
  }
}

.bodyRouter {
  position: absolute;
  z-index: 999;
  bottom: 200px;
  width: 800px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;

  .homepage {
    height: 14vh;
    width: 90px;
    text-align: center;
    z-index: 2;
    text-align: center;
  }

  .homepage .pic {
    height: 80px;
    width: 100%;
    margin-bottom: 10px;
    text-align: center;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .park-info {
    height: 14vh;
    width: 90px;
    z-index: 2;
    text-align: center;
  }

  .park-info .pic {
    height: 80px;
    width: 100%;
    margin-bottom: 10px;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .news-center {
    height: 14vh;
    width: 90px;
    z-index: 2;
    text-align: center;
  }

  .news-center .pic {
    height: 80px;
    width: 100%;
    margin-bottom: 10px;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .resource-pro {
    height: 14vh;
    width: 90px;
    z-index: 2;
    text-align: center;
  }

  .resource-pro .pic {
    height: 80px;
    width: 100%;
    margin-bottom: 10px;

    img {
      width: 80px;
      height: 80px;
    }
  }
}

.index-swiper {
  height: 97vh;
  opacity: 0.8;
  position: relative;
  z-index: 1;
  min-width: 1600px;
}


// /deep/ .ant-btn-primary {
//   background-color: black;
//   border-color: black;
// }

.undershy {
  width: 1200px;
  height: 150px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  top: 35vh;
}

.undershy img {
  height: 100%;
  width: 100%;
}



.goal {
  margin-top: 10px;
  color: white;
  font-size: 18px;
  font-weight: 700;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1600px;
}
</style>